import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducer, { history } from './reducers';
import { routerMiddleware } from 'connected-react-router';
import { loadOverlay } from './overlay/reducer';
import { loadThemes } from './themes/reducer';
import { loadNavigation } from './navigation/reducer';
import { loadUsers } from './user/reducer';
import { loadServices } from './services/reducer';
const asyncInitialState = require('redux-async-initial-state');

// Load Initial State Remote
const loadStore = (getCurrentState: any) => {
    let state = getCurrentState();
    return new Promise(async resolve => {
        state = {
            ...state,
            overlay: await loadOverlay(state.overlay),
            themes: await loadThemes(state.themes),
            navigation: await loadNavigation(state.navigation, window.location),
            user: await loadUsers(state.user),
            services: await loadServices(state.services)
        }
        resolve(state);
    });
}

// Init Enhancers
const composeEnhancers = composeWithDevTools({trace: true, traceLimit: 25});

// Init Middleware
const middleware = [thunk, routerMiddleware(history), asyncInitialState.middleware(loadStore)];

// Create Store
const store = createStore(
    rootReducer,
    composeEnhancers(
        applyMiddleware(...middleware)
    )
);

export default store;